import type { ReduxState } from "./reducers";
import type { IOrderProducedModelEx } from "../reducers/linesOrders";
import type { LineOrders } from "./linesOrders";

export const selectSingleLineMode = (state: ReduxState): boolean => {
    const filters = state.gantt_chart_filters;
    return filters.selected_line_uuids.length === 1 && filters.is_filter_locked;
};

export const getRecommendIncludeUnscheduledStock = (recommendPlans: any): boolean => {
    if (!recommendPlans || recommendPlans.length === 0) {
        return false;
    }

    const lastPlan = recommendPlans[recommendPlans.length - 1];
    return lastPlan?.parameters?.state?.recommend_param_use_productions_of_unscheduled_operations ?? false;
};

const findOrderInLines = (lines: LineOrders[], order_uuid: string): IOrderProducedModelEx | undefined => {
    for (const line of lines) {
        const order = line.orders.find(o => o.uuid === order_uuid);
        if (order) {
            return order;
        }
    }
    return undefined;
};

export const selectOrderByUuid = (state: ReduxState, order_uuid: string): IOrderProducedModelEx | undefined => {
    const { lines_orders, unscheduled_orders } = state.gantt_chart_lines_orders;
    return findOrderInLines(lines_orders, order_uuid) ?? findOrderInLines(unscheduled_orders, order_uuid);
};
